module.exports = __webpack_public_path__ + "media/images/pic/teachers/ryotaro-sakamoto-cc2915c8c83633c84c2b461a41957f76.png";